module.exports = __webpack_public_path__ + "img/认证失败.104d80a2.png";